import {createContext, useCallback, useContext, useEffect, useState} from "react";
import baseUrl from "../baseUrl";
import {requester} from "../services/requester";
import {useAuthContext} from "./AuthContext";

// ЧАСТ К: две числа за сигнализацията в горната лента.
//
// to_approve  — замени, които чакат МОЕТО произнасяне
// my_attention — мои замени, отказани или изтрити отсреща и още неуредени
//
// Второто число е това, което държи целия механизъм: при вариант „г" отказът не
// отменя нищо, тоест ако авторът не разбере, разминаването остава завинаги.
//
// Без периодично допитване — веднъж при зареждане и след всяко действие.

export const ApprovalsContext = createContext();

export const ApprovalsProvider = ({children}) => {
    const {isAuthenticated} = useAuthContext();
    const [counts, setCounts] = useState({to_approve: 0, my_attention: 0});

    const refresh = useCallback(() => {
        if (!isAuthenticated) {
            setCounts({to_approve: 0, my_attention: 0});
            return;
        }
        requester().get(`${baseUrl()}/deals/pending-count`)
            .then(data => setCounts({
                to_approve: data?.to_approve || 0,
                my_attention: data?.my_attention || 0,
            }))
            .catch(() => {
                // Сигнализацията е удобство — ако не се зареди, екранът не гърми.
            });
    }, [isAuthenticated]);

    useEffect(() => {
        refresh();
    }, [refresh]);

    return (
        <ApprovalsContext.Provider value={{...counts, refresh}}>
            {children}
        </ApprovalsContext.Provider>
    );
};

export const useApprovals = () => {
    return useContext(ApprovalsContext);
};
